// Material
import { Stack, Typography, Avatar, Box, Button } from '@mui/material'
import { styled } from '@mui/material/styles'
import { FileTypeIcon } from '$common/icons/file-types/file'
import { formatFileSize, getFileExtension, getFileTitle } from '$func/file'
import { t } from '$i18n'

const Root = styled(Stack)`
  /* @noflip */
  text-align: right;
  box-sizing: border-box;
  /* @noflip */
  padding: 10px 10px 10px 2px;
  overflow: hidden;
  min-height: 70px;
  background-color: white;
  z-index: 1;
`
const InfoContainer = styled(Stack)`
  width: 100%;
  justify-content: center;
  /* @noflip */
  margin-right: 15px;
  overflow: hidden;
`

const StyledSecondaryText = styled(Typography)`
  direction: rtl;
`

interface Props {
  file: File
  onCancel: () => unknown
  hasBorder: boolean
}

export function FilePreview({ file, onCancel, hasBorder }: Props) {
  if (!file) return null

  const avatarSrc = <FileTypeIcon />
  return (
    <Root
      flexDirection="row"
      sx={{
        /* @noflip */
        borderRadius: hasBorder ? '8px 8px 0 0' : 'unset',
      }}
    >
      <Avatar sx={{ width: 50, height: 50, backgroundColor: 'veryLightGray' }}>
        {avatarSrc}
      </Avatar>
      <InfoContainer>
        <Typography variant="caption1" component="div" noWrap>
          {getFileTitle(file.name)}
        </Typography>
        <Box sx={{ display: 'flex', marginTop: '8px' }}>
          <StyledSecondaryText variant="caption1" color="gray">
            {getFileExtension(file.name).toUpperCase()}
          </StyledSecondaryText>
          <StyledSecondaryText
            variant="caption1"
            color="gray"
            sx={{
              /* @noflip */
              margin: '0 2px 0 4px',
            }}
          >
            /
          </StyledSecondaryText>
          <StyledSecondaryText variant="caption1" color="gray" noWrap>
            {`${formatFileSize(file.size).sizeText}`}
          </StyledSecondaryText>
        </Box>
      </InfoContainer>
      <Button sx={{ color: 'error.main' }} onClick={onCancel}>
        {t('common.refuse')}
      </Button>
    </Root>
  )
}
